if ($('.js-share').length > 0) {
    $('.js-share').socialShare({
        social: 'facebook,linkedin,twitter'
    });
}
